module.exports = __webpack_public_path__ + "57387b0694983bc22074ff6014eddf8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/footerLogo.jpg
// module id = qoXb
// module chunks = 0